

























import Vue from 'vue';
export default Vue.extend({
  name: 'RecordItem',
  props: {
    logo: String,   // 业务logo
    merchant: String,   // 业务名称
    date: String,   // 交易记录日期
    amount: String, // 交易金额
    inORout: String,    // 入账为'+'，出账为'-'
    price: String,  // 原价格
    desc: String,   // 状态描述
    isShowBorder: Boolean,    // 是否显示边线
  },
  methods: {
    getLogoStyle(url: string) {
      return {
        backgroundSize: '100% 100%',
        backgroundImage: `url(${url})`,
      }
    },
  }
});
